import React from 'react';
import Hourglass_01 from '../assets/images/Hourglass-01.png';

const WaitingForHost = ({ message }) => (
  <div className="fixed inset-0 p-4 sm:p-6 bg-black bg-opacity-60 flex items-center justify-center z-20">
    <div className="bg-yellow relative backdrop-blur-md rounded-xl w-full max-w-full sm:max-w-xl p-6 sm:p-8 shadow-xl transition-all duration-300 animate-fade-in text-black">

      {/* Rotating Hourglass */}
      <img
        src={Hourglass_01}
        alt="Rotating Hourglass"
        className="w-16 h-16 mx-auto mb-4 animate-spin-slow"
      />

      <h2 className="text-3xl font-bold text-center mb-4">{message}</h2>
    </div>
  </div>
);

export default WaitingForHost;
